import { connect } from 'react-redux';
import { restorePassword } from '../../../actions/auth/actionCreators';
import PasswordRecoveryForm from './PasswordRecoveryForm';


const mapStateToProps = (state) => ({
  isLoading: state.auth.restorePasswordRequest,
  errorMessage: state.auth.restorePasswordError,
});

const mapDispatchToProps = dispatch => ({
  onSubmit: email => dispatch(restorePassword(email)),
});

const PasswordRecoveryFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordRecoveryForm);

export default PasswordRecoveryFormContainer;



// WEBPACK FOOTER //
// src/components/login/PasswordRecoveryForm/PasswordRecoveryFormContainer.js